import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './App'
import {initContract} from './utils'
import {ContainerProvider} from './utils/container'

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./global.css";

// Show loading indicator immediately
const root = createRoot(document.querySelector('#root'))
root.render(
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(to bottom, #1a1a2e, #16213e)',
    color: 'white',
    fontSize: '1.5rem'
  }}>
    <div>
      <div style={{textAlign: 'center', marginBottom: '20px'}}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
      <div>Initializing NEAR connection...</div>
    </div>
  </div>
)

window.nearInitPromise = initContract()
  .then(() => {
    root.render(
      <ContainerProvider>
        <App />
      </ContainerProvider>
    )
  })
  .catch((error) => {
    console.error('Failed to initialize NEAR:', error);
    root.render(
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #1a1a2e, #16213e)',
        color: '#ff6b6b',
        fontSize: '1.2rem',
        padding: '20px'
      }}>
        <div style={{maxWidth: '600px', textAlign: 'center'}}>
          <h2 style={{color: '#ff6b6b', marginBottom: '20px'}}>Initialization Error</h2>
          <p style={{marginBottom: '20px'}}>Failed to initialize NEAR connection.</p>
          <pre style={{
            background: 'rgba(0,0,0,0.3)',
            padding: '15px',
            borderRadius: '5px',
            textAlign: 'left',
            fontSize: '0.9rem',
            overflowX: 'auto'
          }}>
            {error.toString()}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#4a90e2',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Reload Page
          </button>
        </div>
      </div>
    )
  })

